<template>
    <aside id="popup-confirm" class="layout-popup mfp-hide">
        <h2 class="layout-popup-title">
            {{title}}
        </h2>

        <div class="layout-popup-contents">
            {{desc}}
        </div>

        <div class="layout-popup-footer">
            <p class="btns">
                <button class="buttons" data-size="popup" style="cursor: pointer;"
                   @click="clickCancel()">{{$t('COMMON.BUTTON.CAMEL.CANCEL')}}</button>
                <button type="button" class="buttons" data-type="key" data-size="popup" style="cursor: pointer;"
                   @click="clickConfirm()">{{$t('COMMON.BUTTON.UPPER.OK')}}</button>
            </p>
        </div>
    </aside>
</template>

<script>
    export default {
        name: 'confirmPopup',
        data: function () {
            return {
                title: '',
                desc: '',
                callback: null
            }
        },
        created: function () {
            // let self = this;
            // $.magnificPopup.instance.close = function () {
            //     self.clickCancel();
            // }
        },
        methods: {
            open: function(paramTitle, paramDesc, paramCallback) {
                this.title = paramTitle;
                this.desc = paramDesc;
                this.callback = paramCallback;
                $.magnificPopup.open({
                    items: {
                        src: '#popup-confirm'
                    }
                });
            },
            close: function() {
                $.magnificPopup.close();
            },
            clickCancel: function() {
                this.close();
                this.callback(false);
            },
            clickConfirm: function() {
                this.close();
                this.callback(true);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/confirmPopup.vue